var GenericPageModule = (function () {
    function GenericPageModule() {
    }
    return GenericPageModule;
}());
export { GenericPageModule };



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/pages/generic-page/generic-page.module.ts.pre-build-optimizer.js